import useSEO from "../hooks/useSEO";
import PageHero from "../components/PageHero";
import AIAutomationSection from "../components/AIAutomationSection";
import UseCases from "../components/UseCases";
import CTASection from "../components/CTASection";

export default function AIAutomation() {
  useSEO({
    title: "AI & Automation | SefKam Digital Solutions",
    description: "AI agents, RAG applications, LLM integrations, workflow automation and multi-agent systems — practical AI that works with your business.",
    path: "/ai-automation",
  });
  return (
    <>
      <PageHero
        eyebrow="AI & Automation"
        title="AI that works with your business."
        subtitle="We build practical AI solutions that create measurable value — not AI for the sake of AI."
      />
      <AIAutomationSection />
      <UseCases />
      <CTASection
        eyebrow="Build with AI"
        title="Ready to put AI to work?"
        subtitle="Tell us the process you'd like to automate or the assistant you'd like to build."
        primary={{ label: "Build With AI", to: "/contact" }}
      />
    </>
  );
}
